import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './StoreIntro';

const StoreIntroSuspense = dynamic(() => import('./StoreIntro'), {
	loading: () => <BlockLoadingSpinner />,
});

export default function DynamicStoreIntro(props: Props) {
	return <StoreIntroSuspense {...props} />;
}
DynamicStoreIntro.displayName = 'DynamicStoreIntro';
